export function getReferringDomain() {
  if (typeof document !== 'undefined') {
    const referrer = document.referrer;
    if (referrer) {
      return referrer.replace(/(https?:\/\/)?(www.)?/i, '').split('/')[0];
    }
  }
  return undefined;
}
